import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const RotationSection = ({ rotation, onChange, onRotate }) => (
  <div className="space-y-3">
    <h3 className="font-semibold text-sm">Rotación: {rotation}°</h3>
    <Input type="number" min="0" max="360" step="15" value={rotation} onChange={onChange} />
    <div className="flex gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onRotate(-90)}
        className="flex-1"
        title="Rotar 90° a la izquierda"
      >
        ↺ Izq
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onRotate(90)}
        className="flex-1"
        title="Rotar 90° a la derecha"
      >
        Der ↻
      </Button>
    </div>
  </div>
);

export default RotationSection;
